import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/internal/Observable';
import {environment} from '../../../environments/environment';
import {Wallet} from '../interfaces/wallet';

@Injectable({
  providedIn: 'root'
})
export class UserWalletsService {

  constructor(
    private readonly http: HttpClient
  ) {
  }

  public getCurrentUserBalance(): Observable<Wallet[]> {
    const url = `${environment.url}/api/user-wallets`;
    return this.http.get<Wallet[]>(url);
  }
}
